function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M3050 4498l1174 -1414 -138 -1185c-8,-77 21,-150 73,-199 662,-689 1411,-608 1880,264 410,766 297,1225 28,1983l2119 -26c179,-2 554,289 662,427 231,297 188,635 -65,900 -73,78 -166,151 -276,217 495,404 314,801 -154,1113 346,372 326,762 -111,1020 386,461 -196,907 -563,1117 -43,24 -91,34 -136,30l-4298 -14c-129,0 -235,-105 -235,-235l-18 -3842c0,-60 22,-114 58,-156zm413 239l17 3524 4017 13c175,-103 331,-217 379,-320 53,-111 -280,-174 -332,-347 -37,-125 34,-257 159,-294 183,-54 355,-124 407,-207 71,-152 -298,-340 -360,-456 -61,-115 -18,-258 97,-319 568,-304 664,-369 75,-685 -53,-26 -97,-72 -119,-132 -44,-122 19,-258 141,-302 225,-82 396,-181 498,-289 89,-94 120,-176 35,-285 -63,-80 -174,-163 -341,-245l-2407 29c-168,3 -288,-169 -221,-327 297,-708 496,-1197 115,-1908 -278,-518 -621,-636 -1054,-229l131 1134c32,284 -1009,1372 -1237,1645z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M1237 4418l1231 0c130,0 236,106 236,236l0 3870c0,131 -106,237 -236,237l-1231 0c-131,0 -237,-106 -237,-237l0 -3870c0,-130 106,-236 237,-236zm994 473l-758 0 0 3397 758 0 0 -3397z"
}));

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 10000 10000",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1ad2e5d8.svg";
export { ForwardRef as ReactComponent };